import { DateDataEntity } from './../../../../../models/data-entities/date-data-entity';
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { FormActivityInputViewComponent } from '../../form-activity-editor/form-activity-input/form-activity-input-view/form-activity-input-view.component';
import { InspectionNote, InspectionNoteType } from 'src/app/models';
import { Utilities, WorkflowContextService } from 'src/app/services';
import { CompleteInspectionActivity } from 'src/app/models/activities/complete-inspection-activity';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-complete-inspection-activity-input',
    templateUrl: './complete-inspection-activity-input.component.html',
    styleUrls: ['./complete-inspection-activity-input.component.css'],
    standalone: false
})
export class CompleteInspectionActivityInputComponent extends ActivityView
  implements OnInit, OnDestroy {
  @ViewChild('formActivityInputView', { static: false })
    formActivityInputViewCtl: FormActivityInputViewComponent; 

  activity: CompleteInspectionActivity;
  rescheduleForm: UntypedFormGroup;
  cancelForm: UntypedFormGroup;
  bypassForm: UntypedFormGroup;
  rescheduleSelected: boolean;
  cancelSelected: boolean;
  bypassSelected: boolean;
  canceledInAnotherActivity = false;
  bypassedInAnotherActivity = false;
  existingRescheduleReason: InspectionNote = null;
  existingCancelReason: InspectionNote = null;
  existingBypassReason: InspectionNote = null;
  requestActivityResponsibleRole: string;
  scheduleActivityResponsibleRole: string;
  templateForPermitForm: boolean = false
  
  constructor(public layoutService: LayoutService, private _ref: ChangeDetectorRef, context: WorkflowContextService) {
    super();
    //added by juber 30-12-2025

     layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
        //end by priya 30-12-2025



  }

  ngOnInit() {
  const completeApproveControl: AbstractControl =
    this.form.controls['COMPLETE_APPROVE'];

  const completeDate: AbstractControl =
    this.form.controls['COMPLETE_DATE'];

  this.rescheduleForm = new UntypedFormGroup({});
  this.cancelForm = new UntypedFormGroup({});
  this.bypassForm = new UntypedFormGroup({});

  // Add these groups to this.form
  if (this.form) {
    this.form.addControl('rescheduleGroup', this.rescheduleForm);
    this.form.addControl('cancelGroup', this.cancelForm);
    this.form.addControl('bypassGroup', this.bypassForm);
  }

  const completeDateDE = this.activity.model
    .getEntities()
    .find(e => e.templateCode.includes('COMPLETE_DATE')) as DateDataEntity;

  const hasCompleteDate = !!completeDateDE && !!completeDate;

  const completeNotesDE = this.activity.model
    .getEntities()
    .find(e => e.templateCode.includes('COMPLETE_SDL_NOTES'));

  let notesAreRequired = false;

  if (completeNotesDE) {
    notesAreRequired = completeNotesDE.isRequired;
  }

  const completeNotes: AbstractControl = completeNotesDE
    ? this.form.controls[completeNotesDE.templateCode]
    : null;

  if (completeApproveControl) {
    const completeDEValidators = completeDateDE
      ? completeDateDE.getValidators()
      : [];

    const notesDEValidators = completeNotesDE
      ? completeNotesDE.getValidators()
      : null;

    const handleCompleteApproveNonCompleteValues = () => {
      if (hasCompleteDate) {
        completeDateDE.isRequired = false;

        const newValidators = completeDEValidators.filter(
          v => v.toString() !== Validators.required.toString()
        );

        completeDateDE.changeStatus.emit(false);

        completeDate.setValue('');
        completeDate.setValidators(newValidators);
        completeDate.updateValueAndValidity();
      }

      if (completeNotesDE) {
        completeNotesDE.isRequired = false;

        const completeNotesNonRequiredValidators =
          notesDEValidators.filter(
            v => v.toString() !== Validators.required.toString()
          );

        if (completeNotes) {
          completeNotes.setValidators(
            completeNotesNonRequiredValidators
          );
        }
      }
    };

    completeApproveControl.valueChanges.subscribe(e => {
      const value = e?.toString().toLowerCase() ?? '';

      this.resetNonCompleteValues(value);

      if (value.includes('reschedule')) {
        handleCompleteApproveNonCompleteValues();
        this.selectedReschedule();

      } else if (value.includes('cancel')) {
        handleCompleteApproveNonCompleteValues();
        this.selectedCancel();

      } else if (value.includes('bypass')) {
        handleCompleteApproveNonCompleteValues();
        this.selectedBypass();

      } else {
        if (hasCompleteDate) {
          completeDateDE.isRequired = true;

          completeDate.addValidators(Validators.required);
          completeDate.updateValueAndValidity();

          completeDateDE.changeStatus.emit(true);
        }

        if (completeNotesDE) {
          if (notesAreRequired) {
            completeNotesDE.isRequired = true;

            if (completeNotes) {
              completeNotes.addValidators(Validators.required);
            }
          }

          if (completeNotes) {
            completeNotes.setValidators(notesDEValidators);
            completeNotes.updateValueAndValidity();
          }
        }
      }

      if (!this.templateForPermitForm) {
        this.form.updateValueAndValidity();
        this._ref.detectChanges();
      }
    });
  }

  this.requestActivityResponsibleRole =
    this.activity.model.requestActivityResponsibleRole === 'Applicant'
      ? 'Applicant'
      : 'members of the ' +
        this.activity.model.requestActivityResponsibleRole +
        ' role';

  this.scheduleActivityResponsibleRole =
    this.activity.model.scheduleActivityResponsibleRole === 'Applicant'
      ? 'Applicant'
      : 'members of the ' +
        this.activity.model.scheduleActivityResponsibleRole +
        ' role';

  this.setExistingReasons();
}
  ngOnDestroy() {
    if (this.form) {
      this.form.removeControl('rescheduleGroup');
      this.form.removeControl('cancelGroup');
      this.form.removeControl('bypassGroup');
    }
  }

  setExistingReasons() {
    if (this.activity.model.rescheduleReason) {
      this.existingRescheduleReason = this.activity.model.rescheduleReason;
    }

    if (this.activity.model.cancelReason) {
      this.existingCancelReason = this.activity.model.cancelReason;
      
      if (this.activity.model.cancelReason.workflowApplicationActivityDataId.toLowerCase() !== this.activity.activityDataId.toLowerCase()) {
        this.canceledInAnotherActivity = true;
      }
    }

    if (this.activity.model.bypassReason) {
      this.existingBypassReason = this.activity.model.bypassReason;

      if (this.activity.model.bypassReason.workflowApplicationActivityDataId.toLowerCase() !== this.activity.activityDataId.toLowerCase()) {
        this.bypassedInAnotherActivity = true;
      }
    }
  }

  resetNonCompleteValues(currentValue: string) {
    if (!currentValue.includes('reschedule')) {
      this.rescheduleForm.removeControl('rescheduleReason');
      this.rescheduleSelected = false;
      this.activity.model.rescheduleReason = null;
    }
    
    if (!currentValue.includes('cancel')) {
      this.cancelForm.removeControl('cancelReason');
      this.cancelSelected = false;
      this.activity.model.cancelReason = null;
    }
    
    if (!currentValue.includes('bypass')) {
      this.bypassForm.removeControl('bypassReason');
      this.bypassSelected = false;
      this.activity.model.bypassReason = null;
    }
  }

  selectedReschedule() {
    this.rescheduleForm.addControl(
      'rescheduleReason',
      new UntypedFormControl('', Validators.required)
    );

    if (!this.activity.model.rescheduleReason) {
      this.activity.model.rescheduleReason = this.existingRescheduleReason 
      || new InspectionNote({
        id: Utilities.generateId(),
        type: InspectionNoteType.RescheduleReason,
        value: null,
        inspectionId: this.activity.model.inspection.id,
        workflowApplicationActivityDataId: this.activity.activityDataId
      });
    }

    this.rescheduleSelected = true;
  }

  selectedCancel() {
    this.cancelForm.addControl(
      'cancelReason',
      new UntypedFormControl('', Validators.required)
    );

    if (!this.activity.model.cancelReason) {
      this.activity.model.cancelReason = this.existingCancelReason
      || new InspectionNote({
        id: Utilities.generateId(),
        type: InspectionNoteType.CancelReason,
        value: null,
        inspectionId: this.activity.model.inspection.id,
        workflowApplicationActivityDataId: this.activity.activityDataId
      });
    }
    
    this.cancelSelected = true;
  }

  selectedBypass() {
    this.bypassForm.addControl(
      'bypassReason',
      new UntypedFormControl('', Validators.required)
    );

    if (!this.activity.model.bypassReason) {
      this.activity.model.bypassReason = this.existingBypassReason
      || new InspectionNote({
        id: Utilities.generateId(),
        type: InspectionNoteType.BypassReason,
        value: null,
        inspectionId: this.activity.model.inspection.id,
        workflowApplicationActivityDataId: this.activity.activityDataId
      });
    }
  
    this.bypassSelected = true;
  }

  async persistChildComponent() {
    return this.formActivityInputViewCtl.persistChildComponent();
  }
}
